import { ContactAccountantAccess } from '~/models/ContactModel';
export function contactStateKey(contact) {
    if (contact.hasPendingProposals()) return 'pendingProposals';
    if (contact.hasDrafts()) return 'drafts';
    return 'default';
}
export const eligibilityTooltipsTextsPath = 'pages.contactsDashboard.eligibilityTooltips';
export function eligibilityTooltipProps(eligibility, action, texts) {
    if (eligibility.type === 'eligible') return {};
    return {
        title: texts[eligibility.notEligible.reason][action](),
        placement: 'bottom'
    };
}
export const contactBiData = (contact)=>({
        contact: {
            firstName: contact.firstName(),
            lastName: contact.lastName(),
            email: contact.email()
        }
    });
export function getAccountantAccessItem(accountantAccess) {
    switch(accountantAccess){
        case ContactAccountantAccess.NonCandidate:
            return null;
        case ContactAccountantAccess.Active:
            return {
                id: 'remove',
                text: 'Remove Accountant Access',
                skin: 'error'
            };
        case ContactAccountantAccess.Invited:
            return {
                id: 'cancel',
                text: 'Cancel request',
                skin: 'error'
            };
        case ContactAccountantAccess.Candidate:
            return {
                id: 'request',
                text: 'Request Accountant Access'
            };
    }
}
